export default __webpack_public_path__ + "static/media/check_yellow.33543fb0.svg";